import type { ReactNode } from "react";
import type { DocumentShareCollaboratorFragment } from "../client/generated";
import { UserAvatar } from "../users/UserAvatar";

type Props = {
  fragment: DocumentShareCollaboratorFragment;
  right?: ReactNode;
};

export function DocumentShareCollaborator({ fragment, right }: Props) {
  return (
    <div className="flex gap-4 items-center">
      <UserAvatar fragment={fragment} />
      <span>{fragment.username}</span>
      <div className="ml-auto">{right}</div>
    </div>
  );
}
